import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  const benefits = [{
    title: 'Reembolso 100% garantizado',
    desc: 'Te devolvemos hasta el último centavo de tu inversión.'
  }, {
    title: 'Sin preguntas incómodas',
    desc: 'Solo escríbenos un correo y procesamos tu reembolso.'
  }, {
    title: 'El riesgo es nuestro, no tuyo',
    desc: 'Pruébalo sin presión durante una semana completa.'
  }];
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-301">
      {/* Ambient background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-primary/5 rounded-full blur-[140px] pointer-events-none" aria-hidden="true" data-id="element-302"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-303">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_0_50px_rgba(59,130,246,0.12)] rounded-3xl p-6 sm:p-14 relative overflow-hidden" data-id="element-304">
          {/* Inner glow accents */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent" aria-hidden="true" data-id="element-305"></div>
          <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-cta-green/10 rounded-full blur-[80px] pointer-events-none" aria-hidden="true" data-id="element-306"></div>
          <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-primary/10 rounded-full blur-[80px] pointer-events-none" aria-hidden="true" data-id="element-307"></div>

          <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 sm:gap-12 items-center relative z-10" data-id="element-308">
            {/* Guarantee Seal */}
            <div className="flex justify-center md:justify-start" data-id="element-309">
              <div className="relative" data-id="element-310">
                {/* Pulsing ring */}
                <div className="absolute inset-0 rounded-full bg-primary/20 blur-2xl animate-pulse" aria-hidden="true" data-id="element-311"></div>

                {/* Outer rotating ring */}
                <div className="absolute -inset-2 rounded-full border-2 border-dashed border-primary/40" style={{
                animation: 'spin 20s linear infinite'
              }} aria-hidden="true" data-id="element-312"></div>

                {/* Seal */}
                <div className="relative w-40 h-40 sm:w-48 sm:h-48 rounded-full bg-gradient-to-br from-primary/30 via-bg-alt to-bg-alt border-2 border-primary/50 flex flex-col items-center justify-center shadow-[0_0_40px_rgba(59,130,246,0.4)]" data-id="element-313">
                  <ShieldCheckIcon className="w-10 h-10 sm:w-12 sm:h-12 text-primary mb-1 drop-shadow-[0_0_10px_rgba(59,130,246,0.7)]" strokeWidth={2.2} aria-hidden="true" data-id="element-314" />
                  <div className="text-text-main font-black text-4xl sm:text-5xl leading-none tracking-tighter drop-shadow-lg" data-id="element-315">
                    7
                  </div>
                  <div className="text-primary font-black text-xs sm:text-sm tracking-widest mt-1" data-id="element-316">
                    DÍAS
                  </div>
                  <div className="text-text-sec font-bold text-[10px] sm:text-xs tracking-wider mt-0.5" data-id="element-317">
                    GARANTÍA
                  </div>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="text-center md:text-left" data-id="element-318">
              <span className="inline-block text-primary font-bold text-xs sm:text-sm tracking-widest uppercase mb-3 bg-primary/10 px-3 py-1 rounded-full border border-primary/20" data-id="element-319">
                🛡️ Garantía de Hierro
              </span>

              <h2 className="text-2xl sm:text-4xl font-black text-text-main mb-4 tracking-tight leading-tight" data-id="element-320">
                Pruébalo 7 días.{' '}
                <span className="text-primary" data-id="element-321">Si no te encanta,</span>
                <br className="hidden sm:block" data-id="element-322" /> te devolvemos cada centavo.
              </h2>

              <p className="text-text-sec text-base sm:text-lg leading-relaxed font-medium mb-6" data-id="element-323">
                Estamos tan seguros de que el{' '}
                <span className="text-text-main font-bold" data-id="element-324">
                  MegaPack Rugby Listo
                </span>{' '}
                transformará la forma en que entrenas, que asumimos todo el
                riesgo por ti.
              </p>

              {/* Benefits list */}
              <ul className="space-y-3 mb-2" data-id="element-325">
                {benefits.map((b, i) => <li key={i} className="flex items-start gap-3 text-left" data-id="element-326">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-cta-green/20 border border-cta-green/40 flex items-center justify-center mt-0.5" aria-hidden="true" data-id="element-327">
                      <CheckIcon className="w-3.5 h-3.5 text-cta-green" strokeWidth={3} data-id="element-328" />
                    </span>
                    <div data-id="element-329">
                      <p className="text-text-main font-bold text-sm sm:text-base" data-id="element-330">
                        {b.title}
                      </p>
                      <p className="text-text-sec text-xs sm:text-sm leading-relaxed" data-id="element-331">
                        {b.desc}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Signature footer */}
          <div className="mt-8 sm:mt-10 pt-6 border-t border-border-light flex flex-col sm:flex-row items-center justify-between gap-3 relative z-10" data-id="element-332">
            <p className="text-text-sec text-sm italic" data-id="element-333">
              "Si no te ahorra trabajo, no nos lo merecemos."
            </p>
            <p className="text-text-main font-bold text-sm" data-id="element-334">
              — Equipo Rugby Listo 🏉
            </p>
          </div>
        </div>
      </div>
    </section>;
}